import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
window.tippy = tippy;

document.addEventListener('alpine:init', () => {
    Alpine.directive('tooltip', (el, { expression }) => {
        const instance = tippy(el, {
            content: expression,
            allowHTML: true,
            theme: 'tippy',
            // trigger: 'manual',
            // hideOnClick: false,
        });

        // instance.show();
    });
});
